<template>
  <div>
    <field-wrapper label="Country" :error="errors.countries"
                   v-model="values.countries" :options="options.countries" :multiple="true" track-by="code"
                   option-label="name" description="Country that the event takes/took place in."
                   type="select"
                   :close-on-select="false"/>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'countryFilter',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    }
  }
</script>
<style>
</style>
